import React, { useState } from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import { Box, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import SidebarContent from "./SidebarContent";

const ProfileDropdown = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const profileInfo = useSelector(
    (state) => state.profileSlice?.profile?.profile,
  );
  //let role = useSelector((state) => state.auth?.loginDetails?.profile?.role)
  //role = role[0]
  let role = localStorage.getItem("role");

  console.log("profileInfo", profileInfo);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        sx={{
          height: "auto",
          padding: 0,
          border: 0,
          background: "transparent",
          alignItems: "center",
          minWidth: "auto",
          width: {
            xs: "auto",
            sm: "340px",
            md: "340px",
            lg: "auto",
          },
        }}
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        <Box
          component="img"
          src={
            role === "sponsor"
              ? profileInfo?.sponsorProfile?.logo
              : profileInfo?.photo
          }
          alt="profile img"
          sx={{
            objectFit: "cover",
            width: {
              xs: "30px",
              sm: "44px",
            },
            height: {
              xs: "30px",
              sm: "44px",
            },
            borderRadius: "50%",
          }}
        />
        <Typography
          sx={{
            display: {
              xs: "none",
              sm: "block",
            },
            fontSize: {
              xs: "16px",
              sm: "16px",
              md: "16px",
              lg: "18px",
            },
            textTransform: "capitalize",
            fontWeight: 600,
            lineHeight: "23.29px",
            textAlign: "left",
            color: "#2A4876",
            padding: "0 10px",
          }}
        >
          {role === "sponsor"
            ? profileInfo?.sponsorProfile?.companyName
            : profileInfo?.firstName + " " + profileInfo?.lastName}
        </Typography>
        <Box
          component="img"
          src="/images/icons/caret-arrow-down.png"
          alt="profile img"
          sx={{
            width: {
              xs: "10px",
              sm: "20px",
            },
            height: {
              xs: "10px",
              sm: "20px",
            },
          }}
        />
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        sx={{ marginTop: "12px" }}
      >
        <SidebarContent />
      </Menu>
    </>
  );
};

export default ProfileDropdown;
